module.exports = __webpack_public_path__ + "static/media/isl-logo.18a3a1b9.svg";